// extracted by mini-css-extract-plugin
export default {"root":"Page404_root__Y06F0","title":"Page404_title__M9Ycz","control":"Page404_control__FpFMZ","mobileImage":"Page404_mobileImage__VlWfJ","desktopImage":"Page404_desktopImage__LSSdP"};